/**
 * Open/dicht-gedrag voor de taal-dropdown in de topbar
 * (blocks/custom-topbar-language.liquid, alleen-taal-weergave).
 *
 * Bewust niet dropdown-localization-component: die verwacht een
 * localization-form-component in het paneel (roept daarop resetForm() en
 * offsetWidth aan) en gooit anders fouten.
 *
 * Losse asset i.p.v. een {% javascript %}-tag in het block: de lokale
 * bundelaar van `shopify theme dev` genereert een block-scripts.js waarvan de
 * buitenste functie nooit wordt aangeroepen, waardoor de dropdown lokaal niet
 * reageerde.
 */
if (!customElements.get('custom-topbar-language-switcher')) {
  class CustomTopbarLanguageSwitcher extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-language-toggle]');
      this.panel = this.querySelector('[data-language-panel]');
      if (!this.toggleButton || !this.panel) return;

      this.toggleButton.addEventListener('click', this.toggle);
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.toggle);
      this.close();
    }

    toggle = () => {
      if (this.panel.hasAttribute('hidden')) {
        this.open();
      } else {
        this.close();
      }
    };

    open() {
      this.panel.removeAttribute('hidden');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    close() {
      if (!this.panel || this.panel.hasAttribute('hidden')) return;

      this.panel.setAttribute('hidden', '');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onDocumentClick = (event) => {
      if (event.target instanceof Node && !this.contains(event.target)) this.close();
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;

      this.close();
      this.toggleButton.focus();
    };
  }

  customElements.define('custom-topbar-language-switcher', CustomTopbarLanguageSwitcher);
}
